import React, { useEffect } from 'react'
import { Controller, useForm } from 'react-hook-form'
import PropTypes from 'prop-types'
import SydModal from '../../../../commonDesign/SydModal'
import SydLabel from '../../../../commonDesign/SydLabel'
import SydInput from '../../../../commonDesign/SydInput'
import InputColorPicker from '../../../../molecules/InputColorPicker'
import SaveCancelButtons from '../../../../molecules/SaveCancelButtons'
import { modalStyles } from '../TagDetails/TagOptionModal'

const ProductTagModal = ({ open, close, assetTag, assetTagType, submit, isLoading }) => {
  const classes = modalStyles()
  const form = useForm({
    mode: 'onChange',
    defaultValues: {
      TagName: assetTag?.longName || '',
      TagColor: assetTag?.colorField || '#FFFFFF',
      TagOrdinal: assetTag?.ordinal || 0,
      TagShortName: assetTag?.shortName || ''
    }
  })
  useEffect(() => {
    form.reset({
      TagName: assetTag?.longName || '',
      TagColor: assetTag?.colorField || '#FFFFFF',
      TagOrdinal: assetTag?.ordinal || 0,
      TagShortName: assetTag?.shortName || ''
    })
  }, [form, assetTag])
  const submitModal = (data) => {
    const tag = {
      id: assetTag?.classificationTagId,
      typeId: assetTagType?.classificationTagTypeId,
      type: assetTagType?.classificationType,
      shortName: data.TagShortName,
      longName: data.TagName,
      color: data.TagColor,
      ordinal: data.TagOrdinal
    }
    submit(tag)
  }
  return (
    <div>
      <SydModal open={open} onClose={close} title={assetTag?.longName ? 'Edit Asset Tag' : 'New Asset Tag'} size='medium'>
        <form>
          <div className={classes.root}>
            <div className={classes.inputRow}>
              <Controller
                name='TagName'
                rules={{
                  required: 'Tag Name is required'
                }}
                control={form.control}
                render={({ field, fieldState }) => (
                  <SydLabel label='Tag Name' required error={fieldState.error?.message}>
                    <SydInput {...field} />
                  </SydLabel>
                )}
              />
              <Controller
                name='TagShortName'
                control={form.control}
                rules={{
                  required: 'Code is required'
                }}
                render={({ field, fieldState }) => (
                  <SydLabel label='Code' required error={fieldState.error?.message}>
                    <SydInput {...field} />
                  </SydLabel>
                )}
              />
            </div>
            <div className={classes.inputRow}>
              <Controller
                name='TagColor'
                control={form.control}
                rules={{
                  required: 'Color is required'
                }}
                render={(f) => (
                  <SydLabel label='Color' required error={f.fieldState.error?.message}>
                    <InputColorPicker
                      InputProps={{ disableUnderline: true }}
                      value={f.field.value}
                      onChange={f.field.onChange}
                      disableAlpha
                    />
                  </SydLabel>
                )}
              />
              <Controller
                name='TagOrdinal'
                control={form.control}
                rules={{
                  required: 'Tag Ordinal is required'
                }}
                render={({ field, fieldState }) => (
                  <SydLabel label='Tag Ordinal' required error={fieldState.error?.message}>
                    <SydInput {...field} />
                  </SydLabel>
                )}
              />
            </div>
          </div>
          <div className={classes.buttonRow}>
            <SaveCancelButtons onSave={form.handleSubmit(submitModal)} onCancel={close} isSubmitting={isLoading} />
          </div>
        </form>
      </SydModal>
    </div>
  )
}

ProductTagModal.propTypes = {
  open: PropTypes.bool,
  close: PropTypes.func,
  assetTag: PropTypes.object,
  submit: PropTypes.func,
  assetTagType: PropTypes.object,
  isLoading: PropTypes.bool
}

export default ProductTagModal
